// ----------------------------------------------------------------------
// <copyright file="Izenda.PropertiesEditorUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { has, unset, invoke } from 'lodash/fp';
import { action } from 'mobx';
import peManager from 'modules/Izenda.PropertiesEditorManager';

/**
 * Remove unsed-properties
 * @param  {object} fieldSchema
 * @return {object}
 */
function removeProps(propsSchema, unusedProps) {
  if (!has('definedSchema', propsSchema)) {
    return;
  }

  let newSchema = propsSchema.definedSchema;

  // remove un-used properties
  unusedProps.forEach(pathItem => {
    newSchema = unset(pathItem, newSchema);
  });

  // update new schema
  propsSchema.definedSchema = newSchema;
}

function switchToEditor(editorComp, editorData, editor) {
  return peManager.canSwitch(editor).then(
    action(canSwitch => {
      if (canSwitch) {
        invoke('beforeShowProps', editorData);
        peManager.registerByEditors.apply(null, [editorComp, editorData, editor]);
      }

      return canSwitch;
    })
  );
}

function takeAction(actionName, editorName, editorInfo) {
  const editorId = peManager.findEditorIdByName(editorName);
  peManager.takeAction(editorId, actionName, editorName, editorInfo || {});
}

/**
 *
 * @param {Object} schemaDefinition Properties editor GUI schema
 * @param {Object} widgets Widget components using in schema definition
 * @param {Object} mappingProps Compoment properties that are bound to widget component when it renders
 * @param {Object} source Source mapping object
 * @param {Object} mappingSource Source mapping object
 * @param {Function} onChangeValue Handle value changed event
 */
function createSchema(
  schemaDefinition: Object,
  widgets: Object,
  mappingProps: Object,
  source: Object = {},
  mappingSource: Object = {},
  onChangeValue: (
    schemaData: Object,
    changedKey: string,
    changedKeyPath: string,
    changedOthersInfo: Object
  ) => void = () => {}
) {
  ensure(schemaDefinition, 'schemaDefinition must be defined');
  ensure(mappingProps, 'mappingProps must be defined');

  return {
    // define data to render UI
    definedSchema: schemaDefinition,
    // list of widgets which are used to render UI
    widgets,
    // data to binding to fields
    source,
    // properties for different fields
    mappingProps,
    // defined-function which fields need to execute to get its data
    mappingSource,
    onChangeValue
  };
}

export default {
  removeProps,
  switchToEditor,
  takeAction,
  createSchema
};



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.PropertiesEditorUtils.js